import React from 'react'
import { Box } from '@chakra-ui/react'
import WaitlistTable from './components/WaitlistTable'

export default function WaitlistIndex() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <WaitlistTable />
    </Box>
  )
}
